import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.min.css'
import App from './App'
import { configureStore } from './redux/store'
import './i18n'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <Provider store={configureStore()}>
    <React.Fragment>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
)
